import API from "@aws-amplify/api";
import { getCurrentJwt } from "../../../util/jwt/decryptToken";

export async function queryAutosuggest(userPrompt, clientName) {
  const options = {
    headers: {
      Authorization: getCurrentJwt()
    },
    body: {
      userPrompt: userPrompt,
      clientName: clientName
    },
  };
  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await API.post(process.env.REACT_APP_AMPLIFY_API, '/orion/autosuggest', options).then(data => data)
      // res = JSON.parse(res)
      if (res.hasOwnProperty('keywords')) {
        return res.keywords.sort((a,b)=> (b.keyword.S - a.keyword.S))
      }
      else {
        sleepTime *= 2
        await new Promise(resolve => setTimeout(resolve, sleepTime));
      }
    }
    catch (e) {
      console.log(e)
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageUtil/queryAutosuggest.js